import React from "react";
import { useVersionCheck } from "../hooks/useVersionCheck";
import { colors, spacing, typography } from "../utils/designTokens";

/** Aviso fijo abajo cuando hay una versión nueva publicada (ver useVersionCheck). */
export default function VersionBanner() {
  const nueva = useVersionCheck();
  if (!nueva) return null;
  return (
    <div
      role="status"
      style={{
        position: "fixed",
        left: "50%",
        bottom: 16,
        transform: "translateX(-50%)",
        zIndex: 10000,
        display: "flex",
        alignItems: "center",
        gap: spacing[3],
        maxWidth: "calc(100vw - 32px)",
        padding: `${spacing[3]}px ${spacing[4]}px`,
        borderRadius: 12,
        background: colors.gray900,
        color: colors.white,
        fontSize: typography.sizes.base,
        fontWeight: 400,
      }}
    >
      <span>Hay una versión nueva de Habitia.</span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          border: "none",
          borderRadius: 8,
          padding: `${spacing[1]}px ${spacing[3]}px`,
          background: colors.primary,
          color: colors.white,
          fontWeight: 400,
          cursor: "pointer",
        }}
      >
        Actualizar
      </button>
    </div>
  );
}
